export const MEDIA_EVENT_LISTENER = ({
  LOADED_METADATA: 'loadedmetadata',
  TIME_UPDATE: 'timeupdate',
  PROGRESS: 'progress',
  SEEKED: 'seeked',
  ENDED: 'ended',
  ERROR: 'error',
  CAN_PLAY: 'canplay',
  STALLED: 'stalled',
  PLAY: 'play',
  PAUSE: 'pause'
} as const);
export const DOCUMENT_EVENT_LISTENER = ({
  VISIBILITY_CHANGE: 'visibilitychange'
} as const);
export const WINDOW_EVENT_LISTENER = ({
  PAGE_SHOW: 'pageshow'
} as const);